import React from 'react';
const rows = [{
  problem: 'Un percorso previsto di 8-10 sedute che si ferma alla terza',
  cost: 'In Italia una seduta si paga tra €80 e €120: tra un percorso interrotto e uno completo ballano diverse centinaia di euro per cliente'
}, {
  problem: 'Preparare ogni seduta da zero',
  cost: 'Decine di ore non fatturate ogni anno'
}, {
  problem: 'Nessun documento consegnato al cliente',
  cost: 'Il progresso resta invisibile — e quello che non si vede non si racconta a nessuno'
}, {
  problem: 'Nessun accordo di percorso, nessuna informativa privacy',
  cost: 'La tua pratica resta scoperta proprio dove il mercato italiano guarda per primo'
}, {
  problem: 'Nessuna chiusura strutturata',
  cost: 'Ogni percorso finisce in un vicolo cieco invece che in una referenza'
}];
export function CostOfInaction() {
  return <section aria-labelledby="cost-heading" className="w-full bg-cream" data-id="element-78" data-mp="3slm1qa8q31wp">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-79" data-mp="3slue810xo57d">
        <h2 id="cost-heading" className="font-serif font-bold text-ink text-2xl sm:text-4xl text-center" data-id="element-80" data-mp="3ehhpgp3l31hm">
          Quanto costa davvero improvvisare il percorso?
        </h2>

        <div className="mt-8 overflow-hidden rounded-2xl border border-cream-dark shadow-card" data-id="element-81" data-mp="34j1v8d99fc3w">
          <table className="w-full text-left" data-id="element-82" data-mp="30i03sill44ch">
            <thead data-id="element-83" data-mp="11jyp1yxtris">
              <tr data-id="element-84" data-mp="1234jkbbcpgg">
                <th className="w-1/2 bg-danger-soft px-4 sm:px-6 py-3.5 text-xs uppercase tracking-[0.12em] font-bold text-danger" data-id="element-85" data-mp="10icc1ch1ilr">
                  Senza sistema
                </th>
                <th className="w-1/2 bg-cream-dark px-4 sm:px-6 py-3.5 text-xs uppercase tracking-[0.12em] font-bold text-ink" data-id="element-86" data-mp="3ngctpvn2i1ia">
                  Il costo reale
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-cream-dark" data-id="element-87" data-mp="jsuotgwua09m">
              {rows.map(row => <tr key={row.problem} className="bg-white align-top" data-id="element-88" data-mp="f0jc1dh02jzn">
                  <td className="px-4 sm:px-6 py-4 text-[14px] sm:text-[15px] text-ink-soft" data-id="element-89" data-mp="298n6e5yq6n52">
                    <span className="text-danger mr-1.5" aria-hidden="true" data-id="element-90" data-mp="2e800nbrxewho">
                      ✕
                    </span>
                    {row.problem}
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-[14px] sm:text-[15px] font-semibold text-ink" data-id="element-91" data-mp="24igkidvllgqi">
                    {row.cost}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <blockquote className="mt-10 mx-auto max-w-2xl rounded-2xl bg-sage-tint border-l-4 border-sage px-6 py-6 text-center" data-id="element-92" data-mp="1viteferxbmr4">
          <p className="font-serif italic text-lg sm:text-2xl text-sage leading-snug" data-id="element-93" data-mp="1gmc5svb4cm89">
            Un solo percorso portato a termine copre questo sistema più di dieci
            volte.
          </p>
        </blockquote>

        <p className="mt-6 text-center font-semibold text-terracotta text-base sm:text-lg" data-id="element-94" data-mp="3awpi50zn5n34">
          Il tuo prossimo colloquio esplorativo può andare diversamente.
        </p>
      </div>
    </section>;
}